/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function Card({
  header, subHeader, desc, buttonDesc, classNames,
}) {
  return (
    <div className={`card ${classNames}`}>
      <div className="card-body d-flex flex-column">
        <h5 className="card-title">{header}</h5>
        <h6 className="card-subtitle mb-2 text-muted">{subHeader}</h6>
        <p className="card-text">
          {desc}
        </p>
        <div className="text-center mb-2 p-3 mt-auto"><a href="https://cvtherapy.clientsecure.me" target="_blank" rel="noreferrer noopener" className="text-white btn btn-warning">{buttonDesc}</a></div>
      </div>
    </div>
  );
}

Card.propTypes = {
  header: PropTypes.string,
  subHeader: PropTypes.string,
  desc: PropTypes.string,
  buttonDesc: PropTypes.string,
  classNames: PropTypes.string,
};

Card.defaultProps = {
  header: '',
  subHeader: '',
  desc: '',
  buttonDesc: '',
  classNames: '',
};

export default Card;
